(function () {
	'use strict';

	const opts = window.responsiveBlockControlOptions;
	console.log(opts);

	if (!opts || !opts.addCssToHead || !opts.customCss) {
		return;
	}

	// Prevent duplicate injection
	if (document.querySelector('style.rbc-styles')) {
		return;
	}

	const style = document.createElement('style');
	style.className = 'rbc-styles';
	style.textContent = opts.customCss.trim();

	document.head.appendChild(style);
})();
